const API_BASE = import.meta.env.VITE_API_URL || '/api'

export interface CmsPage {
  _id: string
  slug: string
  pageType: string
  title: string
  blocks: CmsBlock[]
}

export interface CmsBlock {
  type: string
  data: Record<string, unknown>
}

export async function fetchCmsPage(pageType: string): Promise<CmsPage | null> {
  try {
    const res = await fetch(`${API_BASE}/cms/page-by-type/${pageType}`)
    if (!res.ok) return null
    // A misrouted request (proxy hiccup / SPA fallback) can answer 200 with an
    // HTML page; parsing that as JSON throws "Unexpected token '<'". Skip the
    // parse when the body isn't JSON so we degrade to static defaults. Note the
    // `await`: `return res.json()` would resolve OUTSIDE this try, so a rejection
    // would escape as an uncaught promise instead of being caught here.
    const contentType = res.headers.get('content-type') || ''
    if (!contentType.includes('application/json')) return null
    return await res.json()
  } catch {
    return null
  }
}
